import $ from 'jquery';
import tippy from 'tippy.js';
//список модулей для свайпера https://swiperjs.com/swiper-api#using-js-modules
import Swiper, {
    Navigation,
    Pagination,
    Scrollbar,
    EffectFade
} from 'swiper';
Swiper.use([Navigation, Pagination, Scrollbar, EffectFade]);

import jqueryValidation from 'jquery-validation';
import 'jquery-validation/dist/localization/messages_ru.min';
window.jqueryValidation = jqueryValidation;

window.jQuery = $;
window.$ = $;

const PubSub = {
    channels: {},
    subscribe(channelName, listener) {
        if (!this.channels[channelName]) {
            this.channels[channelName] = []
        }
        this.channels[channelName].push(listener)
    },

    publish(channelName, data) {
        const channel = this.channels[channelName]
        if (!channel || !channel.length) {
            return
        }

        channel.forEach(listener => listener(data))
    },
}
window.CHANNEL_NAMES = {
    navContacts: 'NAV_CONTACTS_CHANGE',
    hybridMapData: {
        getSuccess: 'SMD_GET_SUCCESS',
        get: 'SMD_GET',
    },
    landChangeFavorites: 'LAND_CHANGE_FAVORITES',
    landShowInfo: 'LAND_SHOW_INFO',
    landModalGeo: {
      render: 'LAND_MODAL_GEO_RENDER',
      set: 'LAND_SET_GEO_FROM_MAP',
      get: 'LAND_GET_GEO_FROM_MAP'
    },
    updModalLandMapBounds: 'UPDATE_MODAL_LAND_MAP_BOUNDS'
}
window.PubSub = PubSub

window.getCookie = (name) => {
    let matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}
window.setCookie = (name, value, options = {}) => {

    options = {
        path: '/',
        ...options
    };

    if (options.expires instanceof Date) {
        options.expires = options.expires.toUTCString();
    }

    let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

    for (let optionKey in options) {
        updatedCookie += "; " + optionKey;
        let optionValue = options[optionKey];
        if (optionValue !== true) {
            updatedCookie += "=" + optionValue;
        }
    }

    document.cookie = updatedCookie;
}

export const mac = navigator.platform.match(/(Mac|iPhone|iPod|iPad)/i) ? true : false;
export const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
isSafari && document.documentElement.classList.add('is-safari');

//pureJS polyfills IE
(function () {

    if (!Element.prototype.closest) { // проверяем поддержку closest
        Element.prototype.closest = function (css) {
            var node = this;

            while (node) {
                if (node.matches(css)) return node;
                else node = node.parentElement;
            }
            return null;
        };
    }

    if (!Element.prototype.matches) { // проверяем поддержку matches
        Element.prototype.matches = Element.prototype.matchesSelector ||
            Element.prototype.webkitMatchesSelector ||
            Element.prototype.mozMatchesSelector ||
            Element.prototype.msMatchesSelector;

    }

})();

export const isMobile = {
    Android: function () {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function () {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function () {
        return navigator.userAgent.match(/IEMobile/i);
    },
    any: function () {
        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
    }
};
export function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this,
            args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}


export class NoScroll {
    constructor(fixedElements) {
        this.fixForIOS12 = true;
        this.gsapScrollTrigger = typeof ScrollTrigger !== 'undefined';

        this.html = document.querySelector('html');
        this.body = document.body;
        this.scrollTop = 0;
        this.scrollWidth = this.getScrollWidth();
        this.fixedElements = document.querySelectorAll(fixedElements);

        this.isScrollOffFlag = false;

        this.createCss();
    }
    createCss() {
        if (this.fixForIOS12) {
            //position: fixed; для запрета скрола при открытии модалок в ios 12 и ниже
            this.css = `
                .noScroll {
                    position: fixed;
                    overflow: hidden;
                }
            `;
        } else {
            this.css = `
            .noScroll {
                overflow: hidden;
            }
        `;
        }

        this.head = document.head || document.getElementsByTagName('head')[0];
        this.style = document.createElement('style');
        this.body.insertBefore(this.style, this.body.childNodes[0]);
        this.style.appendChild(document.createTextNode(this.css));
    }
    getScrollWidth() {
        let outer = document.createElement("div");
        outer.style.visibility = "hidden";
        outer.style.width = "100px";
        outer.style.msOverflowStyle = "scrollbar";

        this.body.appendChild(outer);

        let widthNoScroll = outer.offsetWidth;
        outer.style.overflow = "scroll";

        let inner = document.createElement("div");
        inner.style.width = "100%";
        outer.appendChild(inner);

        let widthWithScroll = inner.offsetWidth;

        outer.parentNode.removeChild(outer);
        return widthNoScroll - widthWithScroll;
    }

    isScrollOff() {
        return this.isScrollOffFlag;
    }

    disableScroll() {

        if (this.fixForIOS12 && this.gsapScrollTrigger) {
            ScrollTrigger.getAll().forEach(st => st.disable());
        }

        this.scrollTop = this.html.scrollTop ? this.html.scrollTop : this.body.scrollTop;
        this.scrollWidth = this.getScrollWidth();

        this.html.classList.add('noScroll');
        this.html.style.top = -this.scrollTop + 'px';
        this.html.style.marginRight = this.scrollWidth + 'px';
        this.html.style.width = 'calc(100% - ' + this.scrollWidth + 'px';
        this.isScrollOffFlag = true;


        if (this.fixedElements[0]) {
            [].forEach.call(this.fixedElements, (el, i) => {
                let elWidth = el.clientWidth;
                let pos = getComputedStyle(el).position;
                let cssWidth = elWidth + this.scrollWidth >= window.innerWidth ? elWidth - this.scrollWidth + 'px' : '';
                if (pos === 'fixed') {
                    el.style.width = cssWidth;
                    el.style.marginRight = this.scrollWidth + 'px';
                }
            });
        }
    }
    enableScroll() {
        this.html.classList.remove('noScroll');
        this.html.style.top = '';
        this.html.style.marginRight = '';
        this.html.style.width = '';


        if (this.fixedElements[0]) {
            [].forEach.call(this.fixedElements, (el, i) => {
                el.style.width = '';
                el.style.marginRight = '';
            });
        }
        this.html.scrollTop = this.scrollTop;
        this.body.scrollTop = this.scrollTop; //fix for ios 12
        this.scrollTop = 0;
        this.isScrollOffFlag = false;

        if (this.fixForIOS12 && this.gsapScrollTrigger) {
            ScrollTrigger.getAll().forEach(st => st.enable());
        }
    }
}
export const noScroll = new NoScroll();


function setCSSVarVH() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}
setCSSVarVH();
window.addEventListener('resize', debounce(setCSSVarVH, 160));

tippy.setDefaultProps({
    placement: 'auto'
});
document.addEventListener('DOMContentLoaded', () => {

    tippy(document.querySelectorAll('[data-tippy-content]'), {
        allowHTML: true,
        appendTo: () => document.body,
        interactive: true,
        // theme: 'infoIcon',
        // interactiveBorder: 15,
        // offset: [-18,1]
    });

});

export function initCustomSwiper(settings) {
    // if ($('div').hasClass(settings.swiperContainer.substr(1))) {
    var scrollWidth = scrollbarWidth();
    var screenWidth = $(window).outerWidth();
    if ((screenWidth <= (settings.width - scrollWidth)) && (settings.swiperVariable == undefined)) {
        $(settings.swiperContainer).addClass('swiper-container');
        if (settings.swiperContainerWrap === undefined) {
            $(settings.swiperContainerSlide).wrapAll("<div class='swiper-wrapper'></div>");
        } else {
            $(settings.swiperContainerWrap).addClass('swiper-wrapper');
        }
        $(settings.swiperContainerSlide).addClass('swiper-slide');
        settings.swiperVariable = new Swiper(settings.swiperContainer, settings.swiperSettings);

        if (settings.swiperUpdateTime != undefined) {
            $(window).on('load', function () {
                setTimeout(function () {
                    settings.swiperVariable.update();
                }, 200);
            });
        }
    } else if ((screenWidth > settings.width - scrollWidth) && (settings.swiperVariable != undefined)) {
        settings.swiperVariable.destroy();
        settings.swiperVariable = undefined;
        $(settings.swiperContainer).removeClass('swiper-container');
        if (settings.swiperContainerWrap === undefined) {
            $(settings.swiperContainerSlide).unwrap();
        } else {
            $(settings.swiperContainerWrap).removeClass('swiper-wrapper');
        }
        $(settings.swiperContainerSlide).removeClass('swiper-slide');
    }
    // }
}

export function scrollbarWidth() {
    var documentWidth = parseInt(document.documentElement.clientWidth);
    var windowsWidth = parseInt(window.innerWidth);
    var scrollbarWidth = windowsWidth - documentWidth;
    return scrollbarWidth;
}